export default __webpack_public_path__ + "static/media/crown_silver.e131220e.svg";